// Соответствие «маршрут → ключи заголовка и подзаголовка» в namespace "menu".
// Используется верхней панелью (Topbar) и заголовками страниц (BlockTitle),
// чтобы не дублировать название раздела внутри содержимого.
//
// icon   — ключ иконки раздела (карта иконок — в Topbar.js);
// parents — промежуточные уровни хлебных крошек (без «Главной» и без
//           текущей страницы: их добавляет сам Topbar).

export const TITLE_BY_PATH = [
  { test: (p) => p === "/", title: "summary", sub: "summary", icon: "summary" },
  { test: (p) => p.startsWith("/schedule"), title: "schedule", sub: "schedule", icon: "schedule" },
  { test: (p) => p.startsWith("/patient"), title: "patients", sub: "patients", icon: "patients" },
  { test: (p) => p.startsWith("/staff"), title: "staff", sub: "staff", icon: "staff" },
  {
    test: (p) => p.startsWith("/warehouse/units"),
    title: "warehouse.units",
    sub: "warehouse",
    icon: "warehouse",
    parents: [{ label: "warehouse.title", to: "/warehouse/" }],
  },
  {
    test: (p) => p.startsWith("/warehouse/logs"),
    title: "warehouse.logs",
    sub: "warehouse",
    icon: "warehouse",
    parents: [{ label: "warehouse.title", to: "/warehouse/" }],
  },
  { test: (p) => p.startsWith("/warehouse"), title: "warehouse.title", sub: "warehouse", icon: "warehouse" },
  { test: (p) => p.startsWith("/services"), title: "services", sub: "services", icon: "services" },
  { test: (p) => p.startsWith("/contacts"), title: "clinics", sub: "clinics", icon: "clinics" },
  { test: (p) => p.startsWith("/knowledge_base"), title: "knowledgeBase", sub: "knowledgeBase", icon: "knowledgeBase" },
  { test: (p) => p.startsWith("/instructions"), title: "instructions.title", sub: "instructions", icon: "instructions" },
  { test: (p) => p.startsWith("/finance"), title: "finance.title", sub: "finance", icon: "finance" },
  { test: (p) => p.startsWith("/templates"), title: "templates.title", sub: "templates", icon: "templates" },
  { test: (p) => p.startsWith("/settings/smtp"), title: "settings.smtp", sub: "settings", icon: "settings" },
  { test: (p) => p.startsWith("/settings"), title: "settings.title", sub: "settings", icon: "settings" },
];

export const resolvePageMeta = (pathname) => {
  const path = pathname || "/";
  return TITLE_BY_PATH.find((item) => item.test(path)) || null;
};

// Пути, на которых заголовок страницы уже показывает верхняя панель
// (это «корни» пунктов меню). Внутри таких страниц свой заголовок-шапка
// больше не нужен — остаются только кнопки действий в верхней панели.
export const SECTION_PATHS = [
  "/",
  "/schedule",
  "/patient",
  "/staff",
  "/warehouse",
  "/warehouse/units",
  "/warehouse/logs",
  "/services",
  "/contacts",
  "/knowledge_base",
  "/finance/accounts",
  "/finance/transaction_history",
  "/templates/treatment_plans",
  "/templates/recommendation",
  "/settings/logs",
  "/settings/integrations",
  "/settings/smtp",
];

export const normalizePath = (pathname) => {
  const path = String(pathname || "/").split(/[?#]/)[0];
  return path.length > 1 ? path.replace(/\/+$/, "") : "/";
};

// true — заголовок раздела уже в верхней панели, дубль не нужен
export const isSectionPage = (pathname) =>
  SECTION_PATHS.includes(normalizePath(pathname));

export default resolvePageMeta;
